// @flow

const formatProgressPercent = (e: ProgressEvent): number => (
    Math.round((e.loaded / e.total) * 100)
);

export default formatProgressPercent;
